// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderOpenTwoToneSvg from "@ant-design/icons-svg/es/asn/FolderOpenTwoTone";
import AntdIcon from '../components/AntdIcon';

var FolderOpenTwoTone = function FolderOpenTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderOpenTwoToneSvg
  }));
};

FolderOpenTwoTone.displayName = 'FolderOpenTwoTone';
export default React.forwardRef(FolderOpenTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FolderOpenTwoTone.js
// module id = 1199
// module chunks = 0